<template>
  <section style="height: 100%">
    <header-template />
    <section class="app-container">
      <!-- 左侧导航菜单 -->
      <slider-bar-template class="slider-container" />

      <!-- 右侧内容区域 -->
      <section class="body-container">
        <a-row class="child-page-title">
          <a v-if="isHasBack" class="back" @click="$router.back()"
            ><a-icon type="rollback" /> 返回</a
          >
          <span :class="!isHasBack ? 'title-before' : ''">{{
            $route.meta.title
          }}</span>
        </a-row>
        <router-view class="child-page-container" />
      </section>
    </section>
  </section>
</template>

<script>
import headerTemplate from "./header";
import sliderBarTemplate from "./sliderbar";
export default {
  components: { headerTemplate, sliderBarTemplate },
  computed: {
    currentRoute() {
      return this.$route;
    },
    isHasBack() {
      return (
        this.$route.name.includes("details") ||
        this.$route.name.includes("add") ||
        this.$route.name.includes("edit")
      );
    },
  },
};
</script>

<style lang="scss" scoped>
.app-container {
  display: flex;
  height: calc(100% - 104px);
  //height: calc(100% - 84px);
  padding: 0 10px;
  margin-top: 20px;
  .slider-container {
    width: 260px;
    background: url("../../assets/image/bg-image/bg-sliderbar.png") no-repeat;
    background-size: 100% 100%;
    padding: 16px;
  }
  .body-container {
    width: calc(100% - 260px);
    height: 100%;
    margin-left: 16px;
    background: url("../../assets/image/bg-image/bg-content.png") no-repeat;
    background-size: 100% 100%;
    position: relative;
    .child-page-container {
      margin: 60px 40px 0px 40px;
      padding-bottom: 10px;
      height: calc(100% - 80px);
      overflow-y: auto;
      overflow-x: hidden;
      -ms-overflow-style: none;
      overflow: -moz-scrollbars-none;
      scrollbar-width: none;
      &::-webkit-scrollbar {
        display: none;
      }
    }
    .child-page-title {
      position: absolute;
      top: 32px;
      left: 50px;
      font-size: 16px;
      // color: rgba(82,154,255,1);

      display: inline-block;
      font-weight: bold;
      letter-spacing: 2px;
      span {
        color: rgb(82, 154, 255);
      }
      .back {
        margin-right: 16px;
        font-size: 15px;
        color: rgba(82, 154, 255, 0.75);
      }
      .title-before {
        &::before {
          content: "";
          width: 9px;
          display: inline-block;
          height: 9px;
          // background: #84ffe9;
          background: #529aff;
          margin-right: 8px;
          border-radius: 1px;
        }
      }
    }
  }
}
</style>
